import { computed } from 'vue';
import { useStore } from 'vuex';
import constants from '@/utilities/constants';
import { useRoute } from 'vue-router';

export default function useEpicFeature() {
  const route = useRoute();
  const store = useStore();

  const epicFeatureAvailable = computed(() => {
    return store.getters.getTeamFeatureEnabled(constants.featureFlagIds.roadmapAndProjects);
  });

  const allowEpicInteraction = () => {
    if (!epicFeatureAvailable.value) {
      store.dispatch('setShowUpgradePlanPopup', constants.featureFlagIds.roadmapAndProjects);
      return false;
    }
    return true;
  };

  const isEpicsBoard = computed(() => route.name === constants.epicsBoardRoute.name);

  const isRoadmapWithoutFeatureFlag = computed(() => {
    return !epicFeatureAvailable.value && isEpicsBoard.value;
  });

  const epicUpgradeBadge = computed(() => {
    return !epicFeatureAvailable.value
      ? {
          badge: {
            icon: 'lock',
            text: 'upgradePlan',
          },
          disabled: true,
        }
      : {};
  });

  return {
    epicFeatureAvailable,
    isRoadmapWithoutFeatureFlag,
    allowEpicInteraction,
    epicUpgradeBadge,
  };
}
